// extracted by mini-css-extract-plugin
export default {"cells-container":"PlacementBoard_cells-container__kYvG7"};